import * as React from "react";

import { AppContext } from "@1js/acui-context";
import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";

export const useV9AppIconEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(appContext, ribbonExperiments.fluentV9IconIsEnabled);
};
